/**
 * Перевод координат из формата градусы/минуты/секунды в десятичный формат
 * @param {number} degrees
 * @param {number} minutes
 * @param {number} seconds
 * @return {number}
 */
export function convertDmsToDecimal({ degrees, minutes, seconds }) {
  // Преобразуем градусы, минуты и секунды в десятичные градусы
  return Number(degrees) + Number(minutes) / 60 + Number(seconds) / 3600
}

/**
 * Перевод координат из десятичного формата в формат градусы/минуты/секунды
 * @param {number} decimal
 * @return {object}
 */
export function convertDecimalToDms(decimal = 0) {
  const degrees = Math.floor(decimal)
  const minutesFloat = (decimal - degrees) * 60
  const minutes = Math.floor(minutesFloat)
  const seconds = ((minutesFloat - minutes) * 60).toFixed(2)

  return {
    degrees,
    minutes,
    seconds: parseFloat(seconds),
  }
}
